export default __webpack_public_path__ + "static/media/detail_mobile_10_8.506387d6.jpg";